// extracted by mini-css-extract-plugin
export default {"butonSwitch":"ConfigureModule_butonSwitch__3+zPJ","rightCorner":"ConfigureModule_rightCorner__PKTC+","header":"ConfigureModule_header__Xo3AC"};